"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _AttachmentTabList = _interopRequireDefault(require("../../components/AttachmentTabList"));

var _default = function _default(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-screen flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-2xl font-semibold text-center text-gray-dark p-4 border-b z-10 bg-app"
  }, t('contactDetail.attachments.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow h-full"
  }, /*#__PURE__*/_react["default"].createElement(_AttachmentTabList["default"], props)));
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map